import React from 'react';
import { DataContext } from '../App';

function AffectedTraps() {
    const data = React.useContext(DataContext);

    const historicalTotalTrapsWithDetection = data.historical_total_traps_with_detection;
    const historicalTotalTraps = data.historical_total_traps;
    const affectedTraps = historicalTotalTraps > 0 ? historicalTotalTrapsWithDetection/historicalTotalTraps : 0; 

    return (
        <div className="card-body d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
                <h1 className="text-black font-weight-bold text-center mb-0">
                    {Math.round(100*affectedTraps).toFixed(0)}%
                </h1>
            </div>
        </div>
    );
}

export default AffectedTraps;